import { render, staticRenderFns } from "./lifangzhuan.vue?vue&type=template&id=c6a6c89c&scoped=true&"
import script from "./lifangzhuan.vue?vue&type=script&lang=js&"
export * from "./lifangzhuan.vue?vue&type=script&lang=js&"
import style0 from "./lifangzhuan.vue?vue&type=style&index=0&id=c6a6c89c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a6c89c",
  null
  
)

export default component.exports